class CSShopByConcern extends HTMLElement {
    constructor() {
        super();

        this.hotspots = this.querySelectorAll('.concern-hotspot');
        this.groupTitles = this.querySelectorAll('.selected-concern');
        this.productGroups = this.querySelectorAll('.concern-product-group');

        this.hotspots.forEach(tab => {
            tab.addEventListener('click', () => {
                let index = tab.dataset.index;

                this.hotspots.forEach(tab => {
                    tab.classList.remove('active');
                });
                tab.classList.add('active');

                this.groupTitles.forEach(group => {
                    group.classList.remove('active');
                });
                this.groupTitles[index].classList.add('active');

                this.productGroups.forEach(group => {
                    group.classList.remove('active');
                });
                this.productGroups[index].classList.add('active');

                const selectedConcernWrapper = document.querySelector('.selected-concern-wrapper');
                selectedConcernWrapper.scrollIntoView({ behavior: 'smooth' });
                
            });
        });
        
    }
}
  
customElements.define('cs-shop-by-concern', CSShopByConcern);
  